import React, { useEffect, useState } from "react";
import UserModal from "./components/UserModal";
import AddUserModal from "./components/AddUserModal";
import { useDispatch } from "react-redux";
import BootstrapTable from 'react-bootstrap-table-next';
import { updateTitle } from "../../redux/updatePageHeadeSlice";
import { ADMIN_DASHBOARD_HEADER } from "../../constants/headerTitles";
import { useQuery } from "react-query";
import getUsersList from "../../api/getUserLists";
import { setSelectedAdminUser } from "../../redux/selectedAdminUser";
import Loader from '../../pages/utilities/loader';
import deactivateAdminUser from "../../api/deactivateAdminUser";
import { showToastAction } from "../../redux/toastSlice";

const AdminPage = () => {
  const [showModal, setShowModal] = useState(false);
  const [userList, setUserList] = useState([])
  const [showAddModal, setShowAddModal] = useState(false);
  const { isLoading, data, refetch } = useQuery('getUsersList', () => getUsersList());

  // const { isLoading, data: documents, refetch } = useQuery("getDocumentsInProgress" + selectedProject.name + form_name, () => getDocumentsInProgress(selectedProject.name, form_name))

  // console.log('isLoading, data ', isLoading, data);
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(updateTitle(ADMIN_DASHBOARD_HEADER))
  }, [])

  useEffect(() => {
    if (data) {
      setUserList(data)
    }
  }, [data])

  const handleModalClose = () => {
    setShowModal(!showModal)
    refetch();
  }
  const handleAddModalClose = () => {
    setShowAddModal(!showAddModal)
    refetch();
  }


  const usersColumns = [
    {
      dataField: 'first_name',
      text: 'Firstname'
    },
    {
      dataField: 'last_name',
      text: 'Lastname'
    },
    {
      dataField: 'username',
      text: 'Username'
    },
    {
      dataField: 'user_type',
      text: 'Type'
    },
    {
      dataField: 'user_status',
      text: 'Status'
    },
    {
      dataField: 'd',
      text: 'Actions',
      headerAlign: 'center',
      formatter: (data, val, rowIndex) => {
        return <div className="d-flex">
          <button className="edit-btn" title="edit" onClick={() => handleEditUser(val)}><i className="ti-pencil-alt"></i></button>
          <button className="remove-btn" title="deactiviate" onClick={() => handleDeleteUser(val?.username)}><i className="ti-trash"></i></button>
        </div>
      },
      style: (cell, row, rowIndex, colIndex) => {
        return {
          width: 50,
        }
      }
    },
  ];


  const handleEditUser = (data) => {
    dispatch(setSelectedAdminUser(data))
    handleModalClose()
  }

  const handleDeleteUser = async (username) => {
    try {
      await deactivateAdminUser(username)
      dispatch(showToastAction({ message: "User Deactivated", showToast: true, severity: "success" }))
      refetch();
    }
    catch (err) {
      dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
    }
  }

  if (isLoading) return <>
    <Loader />
  </>

  return (
    <>
      <UserModal show={showModal} handleClose={handleModalClose} />
      <AddUserModal show={showAddModal} handleClose={handleAddModalClose} />

      <div className="form-documents m-0">
        <div className="d-flex justify-content-end align-items-center mb-4">
          <button className="add-btn" onClick={handleAddModalClose}>
            <i className="ti-plus mr-2"></i> New User
          </button>
        </div>
        <BootstrapTable
          keyField='id'
          data={userList}
          columns={usersColumns}
          hover
          headerClasses="user-tab-class" />
      </div>


    </>
  );
};

export default AdminPage;
